import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const SpecialPriceIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M6.95 2.63a1.025 1.025 0 1 0-.002 2.052A1.025 1.025 0 0 0 6.95 2.63Zm0 1.538a.513.513 0 1 1-.002-1.026.513.513 0 0 1 .002 1.026Z" />
            <path d="M9 5.194V1.606H5.412L4.104 2.914l-.214-.032L3.21 1.5l-.682 1.382L1 3.104 2.104 4.18l-.152.885-.28.279-.362.362.235.235.128.128L4.9 9.295 9 5.194ZM2.672 3.998l-.536-.522.74-.108.331-.673.332.673.74.108-.535.522.126.738-.66-.353-.662.348.124-.732ZM2.036 5.71l.23-.229.944-.498 1.365.717L4.31 4.18l1.11-1.076-.679-.096.887-.888h2.864v2.863L4.9 8.57 2.036 5.709Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const SpecialPriceIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M6.95 2.63a1.025 1.025 0 1 0-.002 2.052A1.025 1.025 0 0 0 6.95 2.63Zm0 1.538a.513.513 0 1 1-.002-1.026.513.513 0 0 1 .002 1.026Z" />
            <path d="M9 5.194V1.606H5.412L4.104 2.914l-.214-.032L3.21 1.5l-.682 1.382L1 3.104 2.104 4.18l-.152.885-.28.279-.362.362.235.235.128.128L4.9 9.295 9 5.194ZM2.672 3.998l-.536-.522.74-.108.331-.673.332.673.74.108-.535.522.126.738-.66-.353-.662.348.124-.732ZM2.036 5.71l.23-.229.944-.498 1.365.717L4.31 4.18l1.11-1.076-.679-.096.887-.888h2.864v2.863L4.9 8.57 2.036 5.709Z" />
        </SvgIcon>
    );
};
